import styled from 'styled-components';

import { Box, Text } from '@gympass/yoga';

import { DrawerContentBoxListLiProps } from './types';

export const DrawerContentTitle = styled(Text)`
  font-size: ${({ theme }) => theme.yoga.fontSizes.xxlarge}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xxlarge}px;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  color: ${({ theme }) => theme.yoga.colors.stamina};
  flex: none;
  align-self: stretch;
`;

export const DrawerContentSubTitle = styled(Text)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular};
  font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  color: ${({ theme }) => theme.yoga.colors.deep};
  flex: none;
  align-self: stretch;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  margin-right: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const DrawerContainerBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 520px;
  height: 408px;
  flex: none;
  gap: ${({ theme }) => theme.yoga.spacing.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.zero};
`;

export const DrawerContentBox = styled(Box)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px;
  gap: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 520px;
  height: 172px;
  border: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.tableBorder};
  flex: none;
  align-self: stretch;
`;

export const DrawerContentBoxTitle = styled(Text)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  font-size: ${({ theme }) => theme.yoga.fontSizes.medium}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.yoga.colors.stamina};
`;

export const DrawerContentBoxListOl = styled.ol`
  list-style: none;
  margin: ${({ theme }) => theme.yoga.spacing.zero};
  padding-left: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const DrawerContentBoxListLi = styled.li<DrawerContentBoxListLiProps>`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular}px;
  font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.small}px;
  list-style: ${({ marker }) => marker};
  color: ${({ theme }) => theme.yoga.colors.stamina};
`;

export const DrawerBoxFooter = styled(Text)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.regular}px;
  font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  color: ${({ theme }) => theme.yoga.colors.deep};
  flex: none;
`;
